/* Left / right arrows for the Judge.me reviews row (tablet + desktop).
   Reuses the "You may also like" arrow style (.ymal-btn). */
(function () {
  function getTrack(widget) {
    return widget.querySelector('.jm-carousel__track');
  }

  function stepSize(track) {
    var card = track.querySelector('.jm-carousel-review-item');
    if (!card) return track.clientWidth * 0.8;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function update(widget) {
    var nav = widget.querySelector('.chits-rev-nav');
    var track = getTrack(widget);
    if (!nav || !track) return;
    var max = track.scrollWidth - track.clientWidth;
    nav.hidden = max <= 2;
    nav.querySelector('.ymal-btn--prev').disabled = track.scrollLeft <= 2;
    nav.querySelector('.ymal-btn--next').disabled = track.scrollLeft >= max - 2;
  }

  function setup(widget) {
    var host = widget.querySelector('.jm-review-widget-minimal-header__button-and-filters');
    var track = getTrack(widget);
    if (!host || !track) return;

    var nav = widget.querySelector('.chits-rev-nav');
    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'ymal-nav chits-rev-nav';
      nav.innerHTML =
        '<button type="button" class="ymal-btn ymal-btn--prev" aria-label="Previous reviews">‹</button>' +
        '<button type="button" class="ymal-btn ymal-btn--next" aria-label="Next reviews">›</button>';
      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('.ymal-btn');
        var t = getTrack(widget);
        if (!btn || !t) return;
        var dir = btn.classList.contains('ymal-btn--prev') ? -1 : 1;
        t.scrollBy({ left: dir * stepSize(t), behavior: 'smooth' });
      });
    }
    if (nav.parentElement !== host) host.appendChild(nav);

    if (!track.dataset.chitsNav) {
      track.dataset.chitsNav = '1';
      track.addEventListener('scroll', function () { update(widget); }, { passive: true });
    }
    update(widget);
  }

  function init() {
    document.querySelectorAll('.jdgm-review-widget').forEach(function (widget) {
      if (widget.dataset.chitsNavInit) return;
      widget.dataset.chitsNavInit = '1';
      var queued = false;
      var run = function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; setup(widget); });
      };
      new MutationObserver(run).observe(widget, { childList: true, subtree: true });
      window.addEventListener('resize', function () { update(widget); });
      run();
    });
  }

  /* stars / "No reviews" under the price: scroll to the reviews section,
     stopping below the sticky header so the heading + "Write a review" show */
  function goToReviews(e) {
    var badge = e.target.closest('.jdgm-preview-badge .jdgm-prev-badge');
    if (!badge) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var header = document.querySelector('.shopify-section-group-header-group');
    var offset = (header ? header.getBoundingClientRect().height : 0) + 24;
    window.scrollTo({
      top: widget.getBoundingClientRect().top + window.scrollY - offset,
      behavior: 'smooth'
    });
  }
  document.addEventListener('click', goToReviews, true);
  document.addEventListener('keydown', goToReviews, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();